import store from "@/store";

export default {
  inserted(el: HTMLElement, binding: any, vnode: any) {
    const value = binding.value;
    const permissions = store.state.user.permissions || [];
    if (JSON.stringify(permissions) == JSON.stringify(["*"])) {
      return;
    }
    if (!value) {
      throw new Error("需要传入权限标识，例如 v-permission=\"'user:add'\"");
    }

    const hasPermission = permissions.includes(value);
    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  },
};
